export class ProductionVersionFilter
{
    id!: number;
    requestId!: number;
    
    constructor()
    {
        
    }
}